import React, { Component } from 'react';
import { 
    Row, 
    Col, 
    Form, 
    Button, 
    ToggleButton,
    ToggleButtonGroup,
    ButtonToolbar, 
    ButtonGroup, 
    InputGroup, 
    FormControl } from 'react-bootstrap';
import Icons from '../icons/Icons';
import InlineSVG from 'svg-inline-react';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Select from 'react-select';
import carColors from './carColors';
import ReactDOMServer from 'react-dom/server';
import './CarInput.css';

class CarInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            make: '',
            keytype: null,
            carkeytype: null,
        };
    }

    
    validate(props) {
        let error = false;
        //console.log('validate props', props.state);
        if (props.state.job.make === '' && props.state.make_ref != null) {
            props.state.make_ref.select.controlRef.className += ' error error-required';
            error = true;
        }
        if (props.state.job.model === '' && props.state.model_ref != null) {
            props.state.model_ref.select.controlRef.className += ' error error-required';
            error = true;
        }
        if (props.state.job.year === '' && props.state.year_ref != null) {
            props.state.year_ref.select.controlRef.className += ' error error-required';
            error = true;
        } 
        if (props.state.job.color === '' && props.state.color_ref != null) {
            props.state.color_ref.select.controlRef.className += ' error error-required';
            error = true;
        }

        //console.log('validate list', props.state.validate_list);
        if (props.state.validate_list.length) {
            props.state.validate_list.map((item, index) => {
                if (typeof(item) == "object") {
                    if (item.value === "") {
                        item.classList.add('error');
                        error = true;
                    }
                } else {
                    switch(item) {
                        case 'trunklock':
                            if (props.state.job.trunklock === '') {
                                props.state.trunklock_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.trunklock_ref.classList.remove('error');
                            }
                            break;
                        case 'description':
                            if (props.state.job_description === '') {
                                props.state.description_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.description_ref.classList.remove('error');
                            }
                            break;
                        case 'number_of_locks':
                            if (props.state.job.numberOfLocks === '') {
                                props.state.number_of_locks_ref.classList.add('error');
                                props.state.button_number_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.number_of_locks_ref.classList.remove('error');
                                props.state.button_number_ref.classList.remove('error');
                            }
                            break;
                        case 'carkeytype':
                            if (props.state.job.keyType === '') {
                                props.state.carkeytype_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.carkeytype_ref.classList.remove('error');
                            }
                            break;
                        case 'locktype':
                            if (props.state.job.lockType === '') {
                                props.state.locktype_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.locktype_ref.classList.remove('error');
                            }
                            break;
                        case 'doorkeytype':
                            if (props.state.job.ignDoorSwitch === '') {
                                props.state.doorkeytype_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.doorkeytype_ref.classList.remove('error');
                            }
                            break;
                        case 'propertytype':
                            if (props.state.job.residentialSwitch === '') {
                                props.state.propertytype_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.propertytype_ref.classList.remove('error');
                            }
                            break;
                        case 'panicbar':
                            if (props.state.job.panicbar === '') {
                                props.state.panicbar_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.panicbar_ref.classList.remove('error');
                            }
                            break;
                        case 'safetype':
                            if (props.state.job.safetype === '') {
                                props.state.safetype_ref.classList.add('error');
                                error = true;
                            } else {
                                props.state.safetype_ref.classList.remove('error');
                            }
                            break;
                    }
                } 
            });
        }
        //console.log('validate', error);
        return error;
    }

    addActive(event, className, list, props, elem, value) {
        list = list.split(' ');
        ////console.log(list, document.getElementsByClassName(list[0])[0].getElementsByClassName(list[1]));
        if (document.getElementsByClassName(list[0])[0].getElementsByClassName(list[1]).length) {
            for ( var i  = 0, len = document.getElementsByClassName(list[0])[0].getElementsByClassName(list[1]).length; i < len; i++ ) {
                let item = document.getElementsByClassName(list[0])[0].getElementsByClassName(list[1])[i];
                item.classList.remove(className);
            }
        }
        event.currentTarget.classList.add(className);
        props.state.job[elem] = value;
        this.validate(props);
    }

    addActiveMany(event, className, list, props, elem, value) {
        if (event.currentTarget.classList.contains(className)) {
            props.state.job[elem] = props.state.job[elem].replace(value + ',', '');
        } else {
            props.state.job[elem] += value + ',';
        }
        event.currentTarget.classList.toggle(className);
        this.validate(props);
    }

    showUpload() {
        this.addimage.click();
    }

    previewUpload(event, props) {
        //console.log('previewUpload', event.target.files[0]);
        let reader = new FileReader();
        reader.onloadend = () => {
            //console.log(this);
            this.updatePreview(reader.result);
            props.updateImage(reader.result);
        }
        reader.readAsDataURL(event.target.files[0]);
    }

    updatePreview(image) {
        this.imagebox.innerHTML = ReactDOMServer.renderToString(<img style={{width: "90px", height: "90px"}} src={image}/>);
    }

    getAddImage(props) {
        var icons = new Icons();
        this.image_upload_content = <span><InlineSVG src={icons.getIcon('pictureIcon')} /><p>Add Image</p></span>
        return (
            <Col md={3} className="text-center imageUpload">
                <input type="file" className="custom-file-input" id="addimage" style={{ height: 1, width: 1 }}  onChange={(e) => this.previewUpload(e, props)} ref={input => this.addimage = input} aria-describedby="inputGroupFileAddon01" />
                <Button variant="outline-dark" onClick={() => this.showUpload()} ref={input => this.imagebox = input} >
                    {this.image_upload_content}
                </Button>
            </Col>
        );
    }

    getTrank(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('trunklock');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Row>
                    <Col xs={3}><span>Trunk Release:</span></Col>
                    <Col xs={6}>
                        <ButtonGroup className="gotlocked-group" ref={(input) => props.state.trunklock_ref = input}>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'trunklock', 'Yes')}}>Yes</Button>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'trunklock', 'No')}}>No</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
            // <Col>
            //     <label>
            //         <span>Trunk Release</span>
            //         <BootstrapSwitchButton
            //             onlabel='Yes'
            //             offlabel='No'
            //             checked={false}
            //             style='w-20 h-20 mx-3'
            //             // ref={input => props.state.validate_list.push(input)}
            //             onChange={(checked) => { props.setState({
            //                 trunklock: checked ? "Yes" : "No"
            //             }) }} 
            //             />
            //     </label>
            // </Col>
        );
    }

    carKeyType(props) {
        var icons = new Icons();
        props.setState(state => {
            const validate_list = state.validate_list.concat('carkeytype');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Row>
                    <p></p>
                </Row>
                <Row className="carkeytype" ref={(elem) => props.state.carkeytype_ref = elem}>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'carkeytype btn', props, 'keyType', 'regular-key')}}>
                            <InlineSVG src={icons.getIcon('regular-key')} />
                            Regular<br /><br />
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'carkeytype btn', props, 'keyType', 'remote-key')}}>
                            <InlineSVG src={icons.getIcon('remote-key')} />
                            Remote Key
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'carkeytype btn', props, 'keyType', 'push-to-start')}}>
                            <InlineSVG src={icons.getIcon('push-to-start')} />
                            Push to Start
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'carkeytype btn', props, 'keyType', 'remote-only')}}>
                            <InlineSVG src={icons.getIcon('remote-only')} />
                            Remote Only
                        </Button>
                    </Col>                                              
                </Row>
            </Col>
        );
    }

    getLockType(props) {
        var icons = new Icons();
        props.setState(state => {
            const validate_list = state.validate_list.concat('locktype');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Row>
                    <p></p>
                </Row>
                <Row className="getlocktype" ref={(input) => props.state.locktype_ref = input}>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'Handle')}}>
                            <InlineSVG src={icons.getIcon('typeHandle')} />
                            Handle
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'Knob')}}>
                            <InlineSVG src={icons.getIcon('knob')} />
                            Knob
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'Dead Bolt')}}>
                            <InlineSVG src={icons.getIcon('deadBolt')} />
                            Deadbolt
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'KeyPad')}}>
                            <InlineSVG src={icons.getIcon('keyPad')} />
                            Key Pad
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'MailBox')}}>
                            <InlineSVG src={icons.getIcon('mailBox')} />
                            Mail Box
                        </Button>
                    </Col>
                    <Col xs={4} md={2}>
                        <Button variant="outline-dark" onClick={(event) => {this.addActiveMany(event, 'active', 'getlocktype btn', props, 'lockType', 'PanicBar')}}>
                            <InlineSVG src={icons.getIcon('panicBar')} />
                            PanicBar
                        </Button>
                    </Col>                                        
                </Row>
            </Col>
        );
    }

    getKeyExtract(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('doorkeytype');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Row>
                    <Col xs={2}><span>Key type:</span></Col>
                    <Col xs={6}>
                        <ButtonGroup className="gotlocked-group" ref={(input) => props.state.doorkeytype_ref = input}>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'ignDoorSwitch', 'IGN')}}>IGN</Button>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'ignDoorSwitch', 'Door')}}>Door</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    getPropertyType(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('propertytype');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Row>
                    <Col xs={3}><span>Property type:</span></Col>
                    <Col xs={6}>
                        <ButtonGroup className="gotlocked-group" ref={(input) => props.state.propertytype_ref = input}>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'residentialSwitch', 'Residential')}}>Residential</Button>
                            <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'residentialSwitch', 'Commercial')}}>Commercial</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
        );
    }

    getDescription(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('description');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <Form.Group controlId="Description">
                    <Form.Label>Description</Form.Label>
                    <Form.Control as="textarea" rows="3" ref={input => props.state.description_ref = input} onChange={(event) => {
                        props.setState({ job_description: event.target.value }); this.validate(props);}} />
                </Form.Group>
            </Col>
        );
    }

    updateNumberOfLocks(n, props) {
        //console.log('updateNumberOfLocks', n);
        props.state.number_of_locks_ref.value = n;
        props.state.job.numberOfLocks = props.state.number_of_locks_ref.value;
    }

    addNumberOfLocks(props) {
        props.state.input_number_ref.classList = "";
        props.state.button_number_ref.classList = "hideNumber";
    }

    getLocks(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('number_of_locks');
            return {
                validate_list,
            };
        });
        return (
            <Col className="number_of_locks">
                <label>
                    <span>Number of locks:</span>
                    <ButtonToolbar ref={input => props.state.button_number_ref = input}>
                            <ToggleButtonGroup type="radio" name="options">
                                <ToggleButton variant="outline-dark" value={1} onClick={() => this.updateNumberOfLocks(1, props)}>1</ToggleButton>
                                <ToggleButton variant="outline-dark" value={2} onClick={() => this.updateNumberOfLocks(2, props)}>2</ToggleButton>
                                <ToggleButton variant="outline-dark" value={3} onClick={() => this.updateNumberOfLocks(3, props)}>3</ToggleButton>
                                <ToggleButton variant="outline-dark" value={4} onClick={() => this.updateNumberOfLocks(4, props)}>4</ToggleButton>
                                <ToggleButton variant="outline-dark" value={5} onClick={() => this.updateNumberOfLocks(5, props)}>5</ToggleButton>
                                <ToggleButton variant="outline-dark" value={6} onClick={() => this.updateNumberOfLocks(7, props)}>6</ToggleButton>
                                <ToggleButton variant="outline-dark" value={7} onClick={() => this.addNumberOfLocks(props)}>+</ToggleButton>
                            </ToggleButtonGroup>
                    </ButtonToolbar>
                    <InputGroup className="hideNumber" ref={input => props.state.input_number_ref = input}>
                        <FormControl
                            type="number" size="2" placeholder="type number"
                            onChange={(event) => this.updateNumberOfLocks(event.target.value, props)}
                            ref={(input) => {props.state.number_of_locks_ref = input;}} />
                    </InputGroup>
                </label>
            </Col>
        );
    }
    
    getPanicBar(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('panicbar');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <ButtonGroup className="gotlocked-group" ref={(input) => props.state.panicbar_ref = input}>
                    <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'panicbar', 'Lockout')}}>Lockout</Button>
                    <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'panicbar', 'Change')}}>Change</Button>
                    <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'panicbar', 'Rekey')}}>Rekey</Button>
                </ButtonGroup>                
            </Col>
        );
    }

    getSafeType(props) {
        props.setState(state => {
            const validate_list = state.validate_list.concat('safetype');
            return {
                validate_list,
            };
        });
        return (
            <Col>
                <ButtonGroup className="gotlocked-group" ref={(input) => props.state.safetype_ref = input}>
                    <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'safetype', 'Lockout')}}>Lockout</Button>
                    <Button variant="outline-dark" onClick={(event) => {this.addActive(event, 'active', 'gotlocked-group btn', props, 'safetype', 'Change')}}>Change</Button>
                </ButtonGroup>                
            </Col>
        );
    }

    getMakeModel(props) {
        // console.log('getMakeModel', props);
        return (
            <Col>
                <Row>
                    <Col>
                        <Form.Group controlId="makeId">
                            <Form.Label>Make</Form.Label>
                            <Select
                                name="make"
                                // value={props.state.make}
                                ref={ref => { props.state.make_ref = ref }}
                                onChange={(value) => props.changeMake(value)}
                                options={props.state.make_list}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="modelId">
                            <Form.Label>Model</Form.Label>
                            <Select
                                name="model"
                                ref={ref => { props.state.model_ref = ref }}
                                onChange={(value) => props.changeModel(value)}
                                options={props.state.model_list}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group controlId="yearId">
                            <Form.Label>Year</Form.Label>
                            <Select
                                name="year"
                                ref={ref => { props.state.year_ref = ref }}
                                onChange={(value) => props.changeYear(value)}
                                options={props.state.year_list}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="colorId">
                            <Form.Label>Color</Form.Label>
                            <Select
                                name="color"
                                ref={ref => { props.state.color_ref = ref }}
                                onChange={(value) => props.chnageColor(value)}
                                options={carColors.map((option, index) => {
                                    return ({ value: option.id, label: option.name })
                                })}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Col>
        );
    }
}


export default CarInput;